/**
 * Created by rastwe on 1/16/2017.
 * @module $Name$
 * @extends React.Component
 */
import React from 'react';
import styled from 'styled-components';
import '@ey-xd/motif-react/index.css';
import './main.less';
import {useDispatch, useSelector} from 'react-redux';
import {versionUpgrade} from '../../../features/version-update/version-update';
import Modal from '../Modal/Modal';
import {currentResource} from '../../../common/utils/utils';

function Main(props) {
	const appVersionState = useSelector((store) => {
		return store.appVersion;
	});
	const dispatch = useDispatch();
	return (
		<>
			<section className="main container">
				<section className="rootcontainerWrapper">{props.children}</section>
			</section>
			<Modal
				title={currentResource.labels.softwareUpdate}
				closeTitle={currentResource.common.close}
				hideCancelButton
				hideConfirmButton
				hideConfirmAndCloseButton={false}
				hideCloseButton
				modalContainerClass="softwareUpdateContainer"
				confirmAndcloseBtnTitle={currentResource.labels.updateNow}
				modalsize="small"
				onHide={() => {
					dispatch(versionUpgrade(false));
				}}
				onConfirmAndCloseClick={() => {
					localStorage.setItem('app.version', appVersionState.version);
					window.location.reload();
				}}
				show={appVersionState.upgrade}
				showButtons
			>
				<PopupContent>{currentResource.labels.updateMsg}</PopupContent>
			</Modal>
		</>
	);
}

export default Main;

const PopupContent = styled.section`
	font-size: 1.2rem;
	margin: 2rem 2rem;
	line-height: 2rem;
	color: ${(props) => props.theme.color[`grey500`]};
`;
